


































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ShelfNoView extends Vue {
  public items: Common.ShelfNo[] = new Array(0);
  public params: Common.ShelfNoQuery = new Common.ShelfNoQuery();
  public importQuery = new Common.ImportQuery('棚番号', 'ShelfNo');
  public exportQuery = new Common.ExportQuery('棚番号', this.params);
  @Prop() public auditNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'warehouse', text: '倉庫'},
    { value: 'commodity', text: '商品'},
    { value: 'sku', text: 'SKU' },
    { value: 'shelfNo', text: '棚番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }

    if (this.commodity){
      this.params.commodity = this.commodity;
    }
    
    if (!this.auditNo && !this.commodity){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    this.$api.formatter.ensureListLoaded('workflow_masterBase');          
  }
  
  public async onCreate(obj: Common.ShelfNo) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    if (this.popup && this.commodity) obj.commodity = this.commodity;        
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.ShelfNo):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }
}
